var render = function render(){var _vm=this,_c=_vm._self._c;return _c('auth-container',{attrs:{"page":_vm.page}},[_c('h2',{staticClass:"mb-4"},[_vm._v("Create New Work Order")]),_c('sr-work-order-form',{attrs:{"item":_vm.item,"set-options":_vm.setOptions}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }